// extracted by mini-css-extract-plugin
export default {"progress":"progress-bar_progress__BsJph"};